<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/ticketPackage/ticketPackageAddTwo')"
    >
      新增
    </a-button>
    <a-button type="danger" :style="{ margin: '0 0 24px 0' }" @click="dels">
      批量删除
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      :row-selection="rowSelection"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, record">
        <a-switch
          checked-children="上架"
          un-checked-children="下架"
          :checked="record.shelf === true ? true : false"
          @change="onChange(record)"
        />
      </span>
      <span slot="recommend" slot-scope="text, record">
        <a-switch
          checked-children="推荐"
          un-checked-children="不推荐"
          :checked="record.recommend === true ? true : false"
          @change="onChangeRecommend(record)"
        />
      </span>
      <template slot="pic" slot-scope="pic">
        <img :src="pic" alt="" />
      </template>
      <template slot="limited1" slot-scope="text">
        <span> {{ text == 0 ? "不限购一份" : text == 1 ? "限购一份" : "" }} </span>
      </template>

      <template slot="packageType" slot-scope="text">
        <span v-if="text == 1" value="1">次数套餐</span>
        <span v-if="text == 2" value="2">年卡套餐</span>
        <span v-if="text == 3" value="3">月卡套餐</span>
        <span v-if="text == 4" value="4">季度卡套餐</span>
        <span v-if="text == 5" value="5">半年卡套餐</span>
        <span v-if="text == 6" value="6">门票套餐</span>
      </template>

      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/ticketPackage/ticketPackageAddTwo?objId=${operate.objId}`
            )
          "
          >编辑</a
        >
        <a @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  getTokensList,
  delsTokensList,
  getSeachList,
  storeUpdown,
  storeRecommend
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "商品名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "封面图",
    dataIndex: "img",
    align: "center",
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "门票类型",
    dataIndex: "packageType",
    align: "center",
    scopedSlots: { customRender: "packageType" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "上下架",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "套餐推荐",
    dataIndex: "recommend",
    align: "center",
    scopedSlots: { customRender: "recommend" },
  },

  {
    title: "门市价",
    dataIndex: "priceShop",
    align: "center",
  },
  {
    title: "限购",
    dataIndex: "limited",
    align: "center",
    scopedSlots: { customRender: "limited1" },
  },
    {
    title: "套餐有效期/天",
    dataIndex: "validDate",
    align: "center",
  },
  {
    title: "支付价",
    dataIndex: "minSpecPrice",
    align: "center",
  },
  {
    title: "显示序号",
    dataIndex: "sortNum",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    width: "15%",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getTokensListData();
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
        onChangeRecommend: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
      };
    },
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      getTokensList(10, this.pagination.current, 653, 655).then((res) => {
        this.data = res.data;
      });
      this.loading = false;
    },
    getTokensListData() {
      this.loading = true;
      getTokensList(10, 1, 653, 655).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    del(row) {
      console.log(row);
      this.loading = true;
      delsTokensList([row.objId]).then((res) => {
        this.getTokensListData();
        message.success("删除成功");
        this.loading = false;
      });
    },
    dels() {
      let idList = this.$store.state.idList;
      delsTokensList(idList).then((res) => {
        this.getTokensListData();
        message.success("删除成功");
      });
    },
    //
    onChange(row) {
      storeUpdown(row.objId, true).then(() => {
        this.getTokensListData();
        message.success(res.info);
      });
    },
      onChangeRecommend(row) {
        storeRecommend(row.objId, true).then(() => {
          this.getTokensListData();
          message.success(res.info);
      });
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    query() {
      this.loading = true;
      getSeachList(
        this.formInline.limit,
        this.formInline.page,
        653,
        655,
        this.formInline.name
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
  },
};
</script>
<style>
img {
  width: 110px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/ticketPackage/ticketPackageHomeContent.vue